import { CognitoCookieStorage } from '@switchsystems/coactive-vue-lib';

export const storage = new CognitoCookieStorage({
  domain: '.coactivecare.co.uk',
  secure: true,
  path: '/',
  expires: 30,
});

const awsconfig = {
  Auth: {
    Cognito: {
      region: 'eu-west-2',
      userPoolId: 'eu-west-2_lDVnN4kYO',
      userPoolClientId: '565bfh7lrdv61tnkkjm12l0nid',
    },
  },
  API: {
    REST: {
      users: {
        endpoint: 'https://users.api.coactivecare.co.uk',
      },
      rota: {
        endpoint: 'https://rota.api.coactivecare.co.uk',
      },
      'rota-kiosk': {
        endpoint: 'https://rota-kiosk.api.coactivecare.co.uk',
      },
      messaging: {
        endpoint: 'https://messaging.api.coactivecare.co.uk',
      },
    },
  },
};

export default awsconfig;
